<template>
  <div style="display: none;">
    <!-- Schema Markup sẽ được inject vào head -->
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { useHead } from '@vueuse/head'

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['Organization', 'WebSite', 'Article', 'Service', 'BreadcrumbList', 'FAQPage'].includes(value)
  },
  data: {
    type: Object,
    required: true
  }
})

const generateSchema = () => {
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': props.type,
    ...props.data
  }

  return JSON.stringify(baseSchema)
}

// Inject schema vào head
useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: generateSchema()
    }
  ]
})
</script>
